module.exports = __webpack_public_path__ + "static/img/40013 (1).e81e73c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40013 (1).webp
// module id = 1LhB
// module chunks = 14